import VueRouter from 'vue-router';
import { isOrdersEnabledForAccount } from '../helper/ordersAccess';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from '../store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';
import { FEATURE_FLAGS } from '../featureFlags';

const routes = [...dashboard.routes];

export const router = new VueRouter({ mode: 'history', routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    window.location = '/app/login';
    return '/app/login';
  }

  if (!to.name) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  if (
    to.name === 'orders_dashboard' &&
    !isOrdersEnabledForAccount(to.params.accountId)
  ) {
    return next(frontendURL(`accounts/${to.params.accountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      const user = store.getters.getCurrentUser;
      const accountId = user?.account_id;

      if (accountId && user) {
        // Get user's role for the current account
        const currentAccount = user.accounts?.find(acc => acc.id === accountId);
        const userRole = currentAccount?.role;
        const isAgent = userRole === 'agent';
        const isAdmin = userRole === 'administrator';

        // Block pipelines access for agents if flag is enabled
        if (
          isAgent &&
          !isAdmin &&
          to.name?.includes('pipelines') &&
          store.getters['accounts/isFeatureEnabledonAccount'](
            accountId,
            FEATURE_FLAGS.HIDE_PIPELINES_FOR_AGENT
          )
        ) {
          return next(frontendURL(`accounts/${accountId}/dashboard`));
        }

        // Block settings access for agents if flag is enabled
        if (
          isAgent &&
          !isAdmin &&
          to.name?.includes('settings') &&
          store.getters['accounts/isFeatureEnabledonAccount'](
            accountId,
            FEATURE_FLAGS.HIDE_SETTINGS_FOR_AGENT
          )
        ) {
          return next(frontendURL(`accounts/${accountId}/dashboard`));
        }
      }

      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
